export { default } from './ScrollTop';


// WEBPACK FOOTER //
// ./src/components/ScrollTop/index.js